<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet, loadingController } from "@ionic/vue"
import { computed, ComputedRef, defineComponent, nextTick, onMounted, onUpdated, watch } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
  },
  setup() {
    const store = useStore()

    const loadingData: ComputedRef = computed(() => {
      return store.getters["main/getLoadingData"]
    })

    const loadingControllers: ComputedRef<any[]> = computed(() => {
      return store.getters["main/getLoadingControllers"]
    })

    const resetLoadingControllers = () => {
      if (loadingControllers.value.length) {
        for (const lc of loadingControllers.value) {
          lc.dismiss()
        }
      }
      store.commit("main/setLoadingControllers")
      const loadingElement = document.querySelectorAll("ion-loading")
      loadingElement.forEach((lc) => {
        lc.remove()
      })
    }

    watch(loadingData, async (loadingData) => {
      nextTick(() => {
        resetLoadingControllers()
      })
      if (loadingData) {
        nextTick(async () => {
          const loadingCtrl = await loadingController.create({
            message: loadingData,
            spinner: "circles",
            cssClass: "pwaf-loading-spinner",
          })
          loadingCtrl.present()
          store.commit("main/setLoadingControllers", loadingCtrl)
        })
      }
    })

    onMounted(() => {
      nextTick(() => {
        resetLoadingControllers()
      })
    })

    onUpdated(() => {
      nextTick(() => {
        resetLoadingControllers()
      })
    })

    return {
      loadingData,
    }
  },
})
</script>

<style lang="scss">
.pwaf-loading-spinner {
  --max-width: 80%;
  --spinner-color: var(--ion-color-primary);
  font-size: 1.5rem;

  .loading-content.sc-ion-loading-ios {
    font-weight: normal;
  }

  .loading-spinner.sc-ion-loading-ios+.loading-content.sc-ion-loading-ios {
    margin-inline-start: 25px;
  }

  ion-spinner {
    transform: scale(2);
  }
}

.image-outer {
  .title {
    p {
      margin: 0.6rem 0 0.8rem;
    }
  }
}

.detail-image-modal {
  &-full {
    .modal-wrapper {
      width: 90%;
      height: 90%;
    }
  }

  &-fullwidth {
    .modal-wrapper {
      width: 90%;
    }
  }

  &-fullheight {
    .modal-wrapper {
      height: 90%;
    }
  }

  &-isize-contain {
    .image-outer {
      background-size: contain;
    }
  }

  &-isize-cover {
    .image-outer {
      background-size: cover;
    }
  }
}

#container.fullheight {
  height: 100%;

  form,
  ion-grid.form-grid,
  ion-row {
    height: 100% !important;
  }
}

ion-label.biglabel {
  font-size: 1.2rem !important;

  &-single {
    display: block;
    text-align: left;
  }
}

ion-item.big-form-item {
  --padding-start: 0;

  ion-label {
    font-size: 1.2rem !important;
  }

  ion-input,
  ion-select,
  ion-label.lookup-label {
    z-index: inherit;
    font-size: 1.4rem !important;
  }
}

.ll-select-interface {
  --min-width: 60%;

  .alert-head {
    padding-top: 5px;
    padding-bottom: 1px;

    .alert-title {
      font-size: 1.8rem;
    }
  }

  .alert-checkbox-group {
    padding: 10px 0;
    max-height: 80vh;
    background-color: #fff;
  }

  .select-interface-option {
    font-size: 1.4rem;
    margin: 5px 0;
  }

  .alert-button {
    font-size: 1.2rem;
    height: 60px;
  }
}

.simple-keyboard.hg-theme-default {
  position: relative;
  z-index: 1000;

  .hg-button {
    height: 60px;
    font-size: 1.3rem;
  }

  .hg-button-numbers,
  .hg-button.hg-functionBtn.hg-button-ent {
    max-width: 80px;
  }
}
</style>